import { object, string } from "yup";

export const whatsappSettingsSchema = object({
    linkTempleteId: string()
        .max(100, "Ödeme/Link Paylaşım Şablon ID en fazla 100 karakter olabilir.")
        .required("Ödeme/Link Paylaşım Şablon ID alanı zorunludur."),
    srcName: string()
        .max(250, "Uygulama Kaynak Adı (Source Name) en fazla 250 karakter olabilir.")
        .required("Uygulama Kaynak Adı (Source Name) zorunludur."),
    errorTempleteId: string()
        .max(100, "Hata/Red Bildirim Şablon ID en fazla 100 karakter olabilir.")
        .required("Hata/Red Bildirim Şablon ID alanı zorunludur."),
    successTempleteId: string()
        .max(100, "İşlem Onay Şablon ID en fazla 100 karakter olabilir.")
        .required("İşlem Onay Şablon ID alanı zorunludur."),
    firmWaNumber: string()
        .max(20, "Whatsapp İşletme Numarası en fazla 20 karakter olabilir.")
        .required("Whatsapp İşletme Numarası alanı zorunludur."),
});